import * as React from "react"
import { Badge } from "./badge"
import { cn } from "@/lib/utils"

function Pill({
    className,
    ...props
}) {
    return (
        <Badge
            className={cn("rounded-full", className)}
            {...props}
        />
    )
}

export { Pill }
